module.exports = __webpack_public_path__ + "media/images/speedometer-174c01e06b45d228a7b695dfa3e5f7a1.svg";